<template>
  <div>
    <div class="flex items-center">
      <h5 class="text-base font-semibold text-gray-500 mr-2">{{anonymousUser.name}}</h5>
      <img  @click="isOpenAnonymousModal = true" :src="anonymousUser.avatar_url" class="w-9 h-9 rounded-full bg-white object-cover cursor-pointer hover:bg-green-500"/>  
      <!-- <Tooltip :text="anonymousUser.name" padding="py-2 px-4" styleTooltip="top-0 right-full mt-1 mr-2" backgroundColor="bg-blueGray-800" textColor="text-xs text-gray-100">
        <img @click="isOpenAnonymousModal = true" :src="anonymousUser.avatar_url" class="w-9 h-9 rounded-full bg-white object-cover cursor-pointer"/>
      </Tooltip> -->
    </div>
    <!-- Modals -->
    <AnonymousCharacterDescriptionModal
      v-if="isOpenAnonymousModal"
      :anonymous_identity="getMyRTUserDetails"
      @close="isOpenAnonymousModal = false"
    />
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  export default Vue.extend({
    components: {
      AnonymousCharacterDescriptionModal: () => import('components/modals/anonymousCharacterDescriptionModal'),
      Tooltip: () => import('../Tooltip.vue')
    },
    data() {
      return {
        defaultUser: {
          name: 'Unknown',
          avatar_url: '/static/avatars/avatar_1.png',
        },
        isOpenAnonymousModal: false,
      };
    },
    computed: {
      ...mapGetters([
        'getMyRTUserDetails',
        'getCurrentRT',
        'hasTeacherPermissionsInCourse',
      ]),
      anonymousUser: function() {
        return this.getMyRTUserDetails || this.defaultUser;
      },
      descriptionTruncated: function() {
        const { description } = this.getMyRTUserDetails;
        if (description) {
          const truncated_string = description.split(' ').splice(0,25).join(' ');
          return truncated_string + '...<br/><strong>(click image to learn more)</strong>';
        } 
        return '';
      },
    },
  });
</script>



// WEBPACK FOOTER //
// identityReveal.vue?19459c58